import { addStyles } from '../theme';
export function createTransformKeyFrame(name, transformFrom, transformTo) {
	addStyles({
		[`@keyframes ${name}`]: { from: { transform: transformFrom }, to: { transform: transformTo } },
	});
}
